import { Injectable } from '@gitlab/needle';
import { AgentSkillsResolver } from '@gitlab-org/ai-context/node';
import {
  DynamicSlashCommandProvider,
  SKILLS_PROVIDER_PRIORITY,
  type DynamicSlashCommandsResult,
} from '../dynamic_slash_command_provider';
import { SlashCommandAction } from '../slash_command_handler';

@Injectable(DynamicSlashCommandProvider, [AgentSkillsResolver])
export class SkillsSlashCommandProvider implements DynamicSlashCommandProvider {
  readonly priority = SKILLS_PROVIDER_PRIORITY;

  #agentSkillsResolver: AgentSkillsResolver;

  constructor(agentSkillsResolver: AgentSkillsResolver) {
    this.#agentSkillsResolver = agentSkillsResolver;
  }

  async getCommands(): Promise<DynamicSlashCommandsResult> {
    const { commands, warnings, conflicts } =
      await this.#agentSkillsResolver.getSkillSlashCommands();

    return {
      commands: commands.map((skill) => ({
        name: skill.name,
        description: skill.description,
        action: SlashCommandAction.Skills,
      })),
      warnings: warnings.map(
        (warning) => `Skipped skill file "${warning.path}": ${warning.reason}`,
      ),
      conflicts,
    };
  }
}
